"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._TrialBookingModularCustomReferences = exports._TrialBookingCustomReferences = void 0;
exports._TrialBookingCustomReferences = {
    datepicker: {
        uid: 'datepicker',
        description: 'A container where the datepicker is shown',
    },
    slotpicker: {
        uid: 'slotpicker',
        description: 'A container where the possible trail booking slots are shown',
        cssClasses: [
            'fittec-trial-booking-slot-wrapper',
            'fittec-trial-booking-slot-text',
            'fittec-trial-booking-slot-wrapper-selected',
            'fittec-trial-booking-slot-text-selected',
        ],
    },
    form: {
        uid: 'form',
        description: 'The form containing customer info required for a trail booking',
    },
    submit: {
        dataTag: 'action',
        uid: 'trailbooking.submit',
        description: 'A button that validates the form',
    },
    webflowSubmit: {
        dataTag: 'action',
        uid: 'webflow-submit',
        description: 'A hidden button that sends the form once validation is successful',
    },
    backButton: {
        dataTag: 'action',
        uid: 'back',
        required: false,
        description: 'A button to hide the form and display the slot selection again',
    },
    selectedSlotWidget: {
        dataTag: 'get',
        uid: 'selectedSlot',
        required: false,
        description: 'A predefined widget that displays information about the selected slot',
    },
    selectedSlotStartTime: {
        dataTag: 'get',
        uid: 'selectedSlotStartTime',
        required: false,
        description: 'A hidden input field that can be used to fill on slot selection the selected slot start date',
    },
    selectedSlotEndTime: {
        dataTag: 'get',
        uid: 'selectedSlotEndTime',
        required: false,
        description: 'A hidden input field that can be used to fill on slot selection the selected slot end date',
    },
    bringsAFriend: {
        dataTag: 'get',
        uid: 'bringsAFriend',
        required: false,
        description: 'A checkbox that shows one clone of data-ref="trialbookingFriendForm" inside its original parent while checked.',
    },
    trialbookingFriendForm: {
        dataTag: 'ref',
        uid: 'trialbookingFriendForm',
        required: false,
        description: 'Optional friend form template. Put it inside a wrapper so that wrapper can be hidden; one clone is shown when data-get="bringsAFriend" is enabled.',
    },
    friendFirstname: {
        dataTag: 'get',
        uid: 'friend.firstname',
        required: false,
        description: 'Friend first name field inside data-ref="trialbookingFriendForm". Clones are indexed before submit.',
    },
    friendLastname: {
        dataTag: 'get',
        uid: 'friend.lastname',
        required: false,
        description: 'Friend last name field inside data-ref="trialbookingFriendForm". Clones are indexed before submit.',
    },
    friendEmail: {
        dataTag: 'get',
        uid: 'friend.email',
        required: false,
        description: 'Friend email field inside data-ref="trialbookingFriendForm". Clones are indexed before submit.',
    },
    friendPhone: {
        dataTag: 'get',
        uid: 'friend.telephone_mobile',
        required: false,
        description: 'Friend phone field inside data-ref="trialbookingFriendForm". Clones are indexed before submit.',
    },
};
exports._TrialBookingModularCustomReferences = {
    trialbookingDescription: {
        dataTag: 'get',
        uid: 'trialbooking-description',
        required: false,
        description: 'Displays the trial booking description inside data-ref="no-trialsession-bookable".',
    },
    appointmentTrainerSwitch: {
        dataTag: 'get',
        uid: 'appointment-trainer-switch',
        required: false,
        description: 'Optional checkbox that limits Fittec calendar trial booking slots to appointments with a trainer.',
    },
    submit: {
        dataTag: 'action',
        uid: 'trailbooking.submit',
        description: 'A button that validates the form and creates the trial booking',
    },
    webflowSubmit: {
        dataTag: 'action',
        uid: 'webflow-submit',
        description: 'A hidden button that sends the form once validation is successful',
    },
    backButton: {
        dataTag: 'action',
        uid: 'back',
        required: false,
        description: 'A button to return to the previous trial booking step',
    },
    nextButton: {
        dataTag: 'action',
        uid: 'next',
        required: false,
        cssClasses: ['disabled'],
        description: 'A button to advance to the next trial booking step. If it is inside a step container, only that step stops auto-advancing. If it is outside all step containers, all steps stop auto-advancing. The module adds the CSS class "disabled" while the required studio, date, or time slot selection is missing and removes it once that selection is made. The class is updated whenever selections change or reset. A button outside all step containers follows the current step.',
    },
    selectedSlotWidget: {
        dataTag: 'get',
        uid: 'selectedSlot',
        required: false,
        description: 'A predefined widget that displays information about the selected slot',
    },
    selectedSlotStartTime: {
        dataTag: 'get',
        uid: 'selectedSlotStartTime',
        required: false,
        description: 'A hidden input field that can be used to fill on slot selection the selected slot start date',
    },
    selectedSlotEndTime: {
        dataTag: 'get',
        uid: 'selectedSlotEndTime',
        required: false,
        description: 'A hidden input field that can be used to fill on slot selection the selected slot end date',
    },
    bringsAFriend: {
        dataTag: 'get',
        uid: 'bringsAFriend',
        required: false,
        description: 'A checkbox that shows one clone of data-ref="trialbookingFriendForm" inside its original parent while checked. Saves trialbooking_bring_a_friend in localStorage as "true" or "false" on load and change, even without a friend form template. If absent, the saved value is "false". Stored selections are not restored automatically.',
    },
    friendFirstname: {
        dataTag: 'get',
        uid: 'friend.firstname',
        required: false,
        description: 'Friend first name field inside data-ref="trialbookingFriendForm". Clones are indexed before submit.',
    },
    friendLastname: {
        dataTag: 'get',
        uid: 'friend.lastname',
        required: false,
        description: 'Friend last name field inside data-ref="trialbookingFriendForm". Clones are indexed before submit.',
    },
    friendEmail: {
        dataTag: 'get',
        uid: 'friend.email',
        required: false,
        description: 'Friend email field inside data-ref="trialbookingFriendForm". Clones are indexed before submit.',
    },
    friendPhone: {
        dataTag: 'get',
        uid: 'friend.telephone_mobile',
        required: false,
        description: 'Friend phone field inside data-ref="trialbookingFriendForm". Clones are indexed before submit.',
    },
};
